import React from 'react'
import { useIntl } from 'react-intl'

import { Text } from '@/components/common'
import { Column, Layout, Rows, Section } from '@/components/layout'
import TextImageRow from '@/components/sections/TextImageRow'
import BuyTry from '@/components/blocks/BuyTry'
import transactionsInApp from '@/assets/management-app/transactions-in-app.jpg'
import docCaptureImport from '@/assets/management-app/mobile-app-document-capture.jpg'
import manageDocs from '@/assets/management-app/manage-docs.jpg'
import accessOrganizeDocs from '@/assets/management-app/access-organize-docs.jpg'
import easySearching from '@/assets/management-app/easy-searching.jpg'

import styles from './expense-management-mobile-app.module.scss'

const pageId = 'expenseManagementMobileApp'

export default function ExpenseManagementMobileApp() {
  const { formatMessage } = useIntl()
  const getPageMessage = (id) => formatMessage({ id: `pages.${pageId}.${id}` })

  return (
    <Layout.Content>
      <Section bgForeground paddingVertical={0} wrapperClassName={styles.wrapper}>
        <Column className="w-full">
          <div className={styles.heroHolder}>
            <div className="max-w-700">
              <Text bold brandSecondary className={styles.tagline} noMargin size="large" type="display">Mobile Receipt Management App</Text>
              <Text.H1 bold normal onTint size="medium">Expense Tracker App to Organize Digital Receipts</Text.H1>
              <Text.P onTint>Capture items on-the-go, review expenses, reconcile documents and more</Text.P>
              <BuyTry justifyStart marginTop={32} noOutline />
              <Text.P onTint size="xsmall">Neat is a yearly subscription where you can add on solutions.</Text.P>
            </div>
          </div>
        </Column>
      </Section>

      <Section className={styles.videoContainer} paddingBottom={0}>
        <div className={styles.videoWrapper}>
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            height="430"
            referrerPolicy="strict-origin-when-cross-origin"
            src="https://www.youtube.com/embed/72FSGByD2nE?si=zoIUUY4MVnODtUqE&rel=0"
            title="YouTube video player"
            width="765"
          />
        </div>
      </Section>

      <Section className={styles.appFeatures} paddingBottom={24}>
        <Rows gap={0}>
          <Column center className={styles.featuresHeader} textCenter>
            <Text.H2 className="c-brand">Receipts Reimagined: Effortless Expense Tracker App</Text.H2>
            <Text.P>Neat's mobile app automatically captures and categorizes receipts, giving you a real-time view of your finances—all from your phone.</Text.P>
          </Column>

          <TextImageRow
            image={transactionsInApp}
            text={getPageMessage('features.transactionsInApp')}
            title="Transactions in Mobile App"
          />
          <TextImageRow
            image={docCaptureImport}
            reverse
            text={getPageMessage('features.docCaptureImport')}
            title="Mobile App Document Capture & Import"
          />
          <TextImageRow
            image={manageDocs}
            text={getPageMessage('features.manageDocuments')}
            title="Manage documents & track transactions for reconciliation"
          />
          <TextImageRow
            image={accessOrganizeDocs}
            reverse
            text={getPageMessage('features.accessOrganizeDocs')}
            title="Access & organize docs in our mobile app"
          />
          <TextImageRow
            image={easySearching}
            text={getPageMessage('features.easySearching')}
            title="Easy Searching"
          />
        </Rows>
      </Section>

      <Section center>
        <Text.H2>Stay Tax-Ready with Digital Receipt Organization</Text.H2>
        <Text.P>Neat ensures all your digital receipts are stored, categorized, and ready for tax season. Maximize deductions and never miss an expense again!</Text.P>
        <BuyTry noOutline />
        <Text.P>Neat is a yearly subscription where you can add on solutions.</Text.P>
      </Section>

    </Layout.Content>
  )
}

ExpenseManagementMobileApp.layoutProps = {
  pageId,
}
